<div class="documarkBannerForm">

    <div class="docuMarkContactForm enterpriseFormCard" id="#OrganizationType">
        <div class="contact_us_form" *ngIf="formSection">
            <h3>Please complete the form to unlock access</h3>                        
            <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                <div class="row">
                    
                    <div class="col-md-12 rightPaddingRemove">
                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                            <mat-form-field appearance="outline">
                                <mat-label>Name*</mat-label>
                                <input matInput placeholder="" formControlName="contactFormName" class="form-control">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-12 rightPaddingRemove">
                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('DesignationTypes').valid && contactForm.get('DesignationTypes').dirty) || (contactForm.get('DesignationTypes').touched && contactForm.get('DesignationTypes').pristine) ? 'TextFiledError' : '' ">
                            <mat-form-field appearance="outline">
                                <mat-label>Designation*</mat-label>
                                <input matInput placeholder="" formControlName="DesignationTypes" class="form-control">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-12 leftPaddingRemove">
                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                            <mat-form-field appearance="outline">
                                <mat-label>Official Email*</mat-label>
                                <input matInput placeholder="" formControlName="contactFormEmail" class="form-control">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-12 rightPaddingRemove">
                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactphoneNo').valid && contactForm.get('contactphoneNo').dirty) || (contactForm.get('contactphoneNo').touched && contactForm.get('contactphoneNo').pristine) ? 'TextFiledError' : '' ">
                            <mat-form-field appearance="outline">
                                <mat-label>Contact Number* (incl. ISD code)</mat-label>
                                <input type="number" matInput placeholder="" formControlName="contactphoneNo" class="form-control">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <input type="text" formControlName="website" style="display:none">
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group text-center">
                        <button type="submit" [disabled]="isSubmitting">
                            <div id="loading"></div>
                            <span>Submit</span>
                        </button>
                    </div>
                </div>

            </form>
        </div>
        <div class="thank_section contact_us_form text-center" *ngIf="thankSection">
            <div class="SVGwrapper">
                <svg width="82px" height="82px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#16A34A" stroke="#16A34A"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>checkmark-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-102.000000, -1141.000000)" fill="#16A34A"> <path d="M124.393,1151.43 C124.393,1151.43 117.335,1163.73 117.213,1163.84 C116.81,1164.22 116.177,1164.2 115.8,1163.8 L111.228,1159.58 C110.85,1159.18 110.871,1158.54 111.274,1158.17 C111.677,1157.79 112.31,1157.81 112.688,1158.21 L116.266,1161.51 L122.661,1150.43 C122.937,1149.96 123.548,1149.79 124.027,1150.07 C124.505,1150.34 124.669,1150.96 124.393,1151.43 L124.393,1151.43 Z M118,1141 C109.164,1141 102,1148.16 102,1157 C102,1165.84 109.164,1173 118,1173 C126.836,1173 134,1165.84 134,1157 C134,1148.16 126.836,1141 118,1141 L118,1141 Z" id="checkmark-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>
              </div>
            <div class="form-group mt-4">
                <h2>Thank You!</h2>
                <p *ngIf="isPdfResource">
                    The attachment has been sent to your email.
                </p>
            </div>
            <div class="btn-group justify-content-center">
                <a [href]="resourceUrl" class="filled-btn" target="_blank">Open Now</a>
            </div>
        </div>
    </div>
</div>